/* Editorial wording for the PeruMagazin draft, including late-loaded cards. */
(()=>{
 const wording=value=>value.replace(/\bentdecke(n)?\b/gi,word=>{
  const replacement=word.toLowerCase()==='entdecken'?'erkunden':'erkunde';
  return word===word.toUpperCase()?replacement.toUpperCase():word[0]===word[0].toUpperCase()?replacement[0].toUpperCase()+replacement.slice(1):replacement;
 });
 function clean(node){
  if(node.nodeType===3){if(node.parentElement?.closest('script,style,textarea,input,[contenteditable]'))return;const value=wording(node.nodeValue);if(value!==node.nodeValue)node.nodeValue=value;return;}
  if(node.nodeType!==1||node.matches('script,style,textarea,input,[contenteditable]'))return;
  for(const attr of ['title','alt','aria-label'])if(node.hasAttribute(attr)){const before=node.getAttribute(attr),after=wording(before);if(before!==after)node.setAttribute(attr,after);}
  [...node.childNodes].forEach(clean);
 }
 function start(){
  document.querySelectorAll('main').forEach(root=>{
   clean(root);
   new MutationObserver(records=>records.forEach(record=>{if(record.type==='characterData')clean(record.target);else record.addedNodes.forEach(clean);})).observe(root,{childList:true,characterData:true,subtree:true});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


(()=>{function repair(){document.querySelectorAll('main img[src*="Mama_Sara_Die_Goettin_des_Maises_der_Inka4.png"]').forEach(img=>{img.removeAttribute('srcset');img.src='https://cdn.shopify.com/s/files/1/0651/5841/4573/files/Mama_Sara_Die_Goettin_des_Maises_der_Inka4.png?v=1778937657';});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',repair,{once:true});else repair();})();
